import { Fragment } from "react";
import ProxyLayouts from "layouts/ProxyLayouts";
import Hero from "container/proxy/shared/Hero";
import Features from "container/proxy/residential/Features";
import PricingPlan from "container/proxy/residential/PricingPlan";
import Testimonial from "container/home/Testimonial";
import BuyProxies from "container/home/BuyProxies";

const SharedProxy = () => {
    return (
        <Fragment>
            <Hero />
            <Features />
            <PricingPlan />
            <Testimonial />
            <BuyProxies />
        </Fragment>
    );
};

export default SharedProxy;